import authPartner from '../../fields/other/authPartner';

export const MUTATION_ADD_AUTH_PARTNER = /* GraphQL */ `
	mutation($input: AuthPartnerInput!) {
		addAuthPartner(input: $input) {
			secretKey
			authPartner {
				${authPartner}
			}
		}
	}
`;
